module.exports = __webpack_public_path__ + "media/images/vp/icon.vk.red-a8fb76739ad95628c32bd5049ee2938e.png";